import qs from 'query-string';

import IdentificationRequests, {
  IIdentificationRequest,
  IIdentificationRequestApi,
  IPaginationResultRequests,
} from '@models/IdentificationRequests.model';

import { onboarding } from '@services';

interface IRequest {
  status?: string | null;
  assignedId?: string;
  id?: string;
  studioId?: string;
}

const getIdentificationRequests = async ({
  status,
  assignedId,
  id,
  studioId,
}: IRequest): Promise<IPaginationResultRequests<IIdentificationRequest>> => {
  const query = {
    status,
    assignedId,
    id,
    studioId,
  };

  const queryString = qs.stringify(query);

  const { data: assets } = await onboarding.get<
    IPaginationResultRequests<IIdentificationRequestApi>
  >(`api/v1/file/irequest?${queryString}`);

  return IdentificationRequests.arrayPaginatedFromApiModel(assets);
};

export { getIdentificationRequests };
